import coverImg from "assets/images/v142/bg.webp"
import pictureImg from "assets/images/v142/cover.webp"
import titleImg from "assets/images/v142/title.webp"

export const v142Config = {
  cover: {
    en: coverImg,
  },
  title: {
    en: titleImg,
  },
  picture: pictureImg,
}
